import { render, staticRenderFns } from "./LogoSection.vue?vue&type=template&id=4dbb93d1&scoped=true&"
import script from "./LogoSection.vue?vue&type=script&lang=ts&"
export * from "./LogoSection.vue?vue&type=script&lang=ts&"
import style0 from "./LogoSection.vue?vue&type=style&index=0&id=4dbb93d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb93d1",
  null
  
)

export default component.exports